import React from "react";
import type { FC } from "react";

import { useFavouriteState } from "./FavouriteProvider.state";
import { FavouriteProviderContext } from "./FavouriteProvider.context";

const FavouriteProviderContextProvider = FavouriteProviderContext.Provider;

const FavouriteProvider: FC = (props) => {
  const { children } = props;

  const state = useFavouriteState();

  return <FavouriteProviderContextProvider value={state}>{children}</FavouriteProviderContextProvider>;
};

export { FavouriteProvider };
